import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (credentials) => ({
                url: 'auth/login',
                method: 'POST',
                body: credentials
            })
        }),
        register: builder.mutation({
            query: (payload) => ({
                url: 'auth/register',
                method: 'POST',
                body: payload
            })
        }),
        userInfo: builder.mutation({
            query: () => ({
                url: 'auth/info',
                method: 'GET'
            })
        }),
        logout: builder.mutation({
            query: () => ({
                url: 'auth/logout',
                method: 'GET'
            })
        }),
        changePassword: builder.mutation({
            query: (payload) => ({
                url: 'auth/change-password',
                method: 'POST',
                body: payload
            })
        }),
        forgotPassword: builder.mutation({
            query: (payload) => ({
                url: 'auth/forgot-password',
                method: 'POST',
                body: payload
            })
        }),
        resetPassword: builder.mutation({
            query: (payload) => ({
                url: 'auth/reset-password',
                method: 'POST',
                body: payload
            })
        })
    })
})

export const { useLoginMutation, useRegisterMutation, useUserInfoMutation, useLogoutMutation, useChangePasswordMutation, useForgotPasswordMutation, useResetPasswordMutation } = authApi;